module.exports = __webpack_public_path__ + "media/images/career_camp/2023/landscape_item_2-62310e766c8f7dc76fd87e90e4acbc47.png";